import * as con from "../../GlobalConstants.js";


export const selectAllTransactionsOk = (state) => {
  const status = state[con.REDUCER_TRANSACTIONS][con.TRANSACTIONS_LOADED];

  const requiredTypes = [
    con.EXPOSURES,
    con.COVERAGES_FWD,
    con.COVERAGES_SPOT,
    con.COVERAGES_OPTION,
    con.ACCOUNTS,
  ];

  return requiredTypes.every(
    type => status[type] === con.OK
  );
};